export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      code: 200000,
      meta: {
        rank: 0,
        total: 3
      },
      data: [
        {
          code: '01-01-01',
          full_name: '株式会社ツルハ-北海道-北海道第１店舗運営部',
          name: '北海道第１店舗運営部'
        },
        {
          code: '01-01-02',
          full_name: '株式会社ツルハ-北海道-北海道第２店舗運営部',
          name: '北海道第２店舗運営部'
        },
        {
          code: '01-01-03',
          full_name: '株式会社ツルハ-北海道-北海道第３店舗運営部',
          name: '北海道第３店舗運営部'
        },
        {
          code: '01-01-04',
          full_name: '株式会社ツルハ-北海道-北海道第４店舗運営部',
          name: '北海道第４店舗運営部'
        },
        {
          code: '01-02-01',
          full_name: '株式会社ツルハ-東北-東北第１店舗運営部',
          name: '東北第１店舗運営部'
        },
        {
          code: '01-02-02',
          full_name: '株式会社ツルハ-東北-東北第２店舗運営部',
          name: '東北第２店舗運営部'
        }
      ]
    }
  }
}
